module.exports = __webpack_public_path__ + "img/infography.55d6a868.jpg";